import script from "./BaseFixedAsideElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFixedAsideElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseFixedAsideElement.vue?vue&type=style&index=0&id=22af2c02&lang=scss"

const __exports__ = script;

export default __exports__